/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_TitleInputs */

const en_wallet_card_title = /** @type {(inputs: Wallet_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Wallet Cards`)
};

const fr_wallet_card_title = /** @type {(inputs: Wallet_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes cartes de portefeuille`)
};

/**
* | output |
* | --- |
* | "My Wallet Cards" |
*
* @param {Wallet_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_title = /** @type {((inputs?: Wallet_Card_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_title(inputs)
	return fr_wallet_card_title(inputs)
});